// Full url of an uploaded document (file_path comes from the documents API)
export const documentUrl = (doc) => process.env.REACT_APP_APIURL + doc.file_path;

// The API is on another domain, so the download attribute alone opens the file
// instead of saving it. Fetch it and save with the original file name.
export const downloadDocument = async (doc) => {
    try {
        const response = await fetch(documentUrl(doc));
        if (!response.ok) throw new Error("Download failed");
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = doc.original_name || doc.file_name;
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error: ", error);
        window.open(documentUrl(doc), "_blank");
    }
};

// PDF and images open in the browser, other files (Word/Excel) are downloaded
export const viewDocument = (doc) => {
    if (doc.type === "application/pdf" || (doc.type || "").startsWith("image/")) {
        window.open(documentUrl(doc), "_blank");
    } else {
        downloadDocument(doc);
    }
};
